/* Elanessa: ws-ugc behaviour. Moved out of the section's inline <script> on 2026-09-03 so it
   loads deferred and cached instead of running mid-parse. One init per root element;
   re-runs for sections added in the theme editor. */
(function () {
  function init(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    var track = root.querySelector('[data-wk-track]');
    var slides = root.querySelectorAll('.wk-ugc__slide');
    var dots = root.querySelector('[data-wk-dots]');

    var arrows = root.querySelector('.wk-ugc__arrows');

    // One dot per scroll position rather than per slide — with 6 cards and 4
    // in view there are 3 stops, which is what the ingredient carousel shows.
    function pageCount() {
      var w = slideWidth();
      if (!track || !w) return 1;
      var perView = Math.round(track.clientWidth / w);
      return Math.max(1, slides.length - perView + 1);
    }

    function buildDots() {
      if (!dots) return;
      var count = pageCount();
      var scrollable = track && track.scrollWidth > track.clientWidth + 1;

      // Every card visible: the controls would be decoration. Hide them.
      if (arrows) arrows.classList.toggle('is-hidden', !scrollable || count <= 1);
      if (dots.children.length === count) return mark(currentIndex());

      dots.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'wk-ugc__dot';
        d.setAttribute('role', 'tab');
        d.setAttribute('aria-label', 'Slide ' + (i + 1));
        d.dataset.index = i;
        d.addEventListener('click', function () { goTo(Number(this.dataset.index)); });
        dots.appendChild(d);
      }
      mark(currentIndex());
    }

    function currentIndex() {
      var w = slideWidth();
      if (!track || !w) return 0;
      return Math.min(pageCount() - 1, Math.max(0, Math.round(track.scrollLeft / w)));
    }

    function mark(i) {
      if (!dots) return;
      Array.prototype.forEach.call(dots.children, function (d, n) {
        d.setAttribute('aria-selected', n === i ? 'true' : 'false');
        d.classList.toggle('is-active', n === i);
      });
    }
    function slideWidth() {
      var s = slides[0];
      return s ? s.getBoundingClientRect().width + 16 : (track ? track.clientWidth * 0.7 : 0);
    }
    function goTo(i) {
      if (!track) return;
      track.scrollTo({ left: i * slideWidth(), behavior: 'smooth' });
      mark(i);
    }
    function step(dir) {
      if (!track) return;
      var i = Math.max(0, Math.min(pageCount() - 1, currentIndex() + dir));
      goTo(i);
    }

    var prev = root.querySelector('[data-wk-prev]');
    var next = root.querySelector('[data-wk-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    if (track) {
      track.addEventListener('scroll', function () { mark(currentIndex()); }, { passive: true });
      window.addEventListener('resize', buildDots);
      buildDots();
    }

    root.querySelectorAll('.wk-ugc__card').forEach(function (card) {
      card.addEventListener('click', function () {
        var src = card.dataset.video;
        if (!src || card.classList.contains('is-playing')) return;
        var v = document.createElement('video');
        v.src = src; v.controls = true; v.playsInline = true; v.preload = 'metadata';
        card.innerHTML = '';
        card.appendChild(v);
        card.classList.add('is-playing');
        v.play().catch(function () {});
      });
    });
  }
  function initAll(scope) {
    (scope || document).querySelectorAll('[data-elanessa-init="ugc"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
